import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

Sentry.init({
  dsn: "https://2740705fe2ca0e6cd12dad63062b4bec@o4511224111104000.ingest.us.sentry.io/4511224122048512",
  environment: import.meta.env.MODE,
  // Customer names, phones and invoice amounts must not reach Sentry: no default
  // PII (IP/user) and error replays are fully masked (launch readiness L-4).
  sendDefaultPii: false,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
  ],
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0.0,
  replaysOnErrorSampleRate: 1.0,
});

createRoot(document.getElementById("root")!).render(<App />);
